import { useMemo } from 'react';
import getLocalitySuburb from '../utils/getLocalitySuburb';

const useLocalitySuburb = (locations, suburb, state, postcode) => {
  const locality = useMemo(
    () => getLocalitySuburb(locations, suburb, state, postcode),
    [locations]
  );

  return locality;
};

export default useLocalitySuburb;
